import styled from 'styled-components';
import { media, mediaQuery } from '../../common/styles/styleUtil';

export const ErrorWrapper = styled.div`
  display: flex;
  padding-bottom: 186px;
  padding-top: 128px;
  @media (${mediaQuery.tablet}) {
    flex-direction: column;
    padding-top: 64px;
    padding-bottom: 128px;
  }
  ${media.xs`
     padding-top: 64px;
     padding-bottom: 128px;
  `};
  .error-icon {
    width: 50%;
    display: flex;
    justify-content: flex-end;
    padding: 0 74px;
    svg {
      width: 442px;
    }
    @media (${mediaQuery.tablet}) {
      width: 100%;
      justify-content: center;
    }
    ${media.xs`
       width:100%
       justify-content: center;
       svg {
        width: 287px;
       }
  `};
  }

  .error-info {
    width: 50%;
    align-self: center;
    @media (${mediaQuery.tablet}) {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    ${media.xs`
       width:100%;
       display: flex;
       flex-direction: column;
       align-items: center;
    `};
    .title {
      height: 60px;
      line-height: 60px;
      font-size: 80px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      color: #333f48;
      margin-bottom: 16px;
      @media (${mediaQuery.tablet}) {
        margin-top: 42px;
        height: 57px;
        font-size: 48px;
      }
      ${media.xs`
          margin-top:42px;
          height:57px;
          font-size: 48px;
      `};
    }
    .sub-title {
      font-size: 32px;
      font-weight: bold;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #333f48;
      margin-bottom: 16px;
      @media (${mediaQuery.tablet}) {
        font-size: 24px;
        text-align: center;
        padding: 0 16px;
      }
      ${media.xs`
        font-size: 24px;
        text-align:center;
        padding: 0 16px;
      `};
    }
    .description {
      font-size: 16px;
      font-weight: 500;
      line-height: normal;
      letter-spacing: normal;
      color: #566271;
      ${media.xs`
        width:256px;
        text-align:center;
    `};
    }
    button {
      width: 157px;
      height: 40px;
      border-radius: 3px;
      border: solid 1px #2b6ed2;
      color: #2b6ed2;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: normal;
      text-align: center;
      background-color: white;
      &:hover {
        cursor: pointer;
      }
    }
  }
`;
